module.exports = __webpack_public_path__ + "static/img/patho-pus-low-CBmu86CR.e98c2410.png";